import React, {Component} from 'react'
import TutorRow from "./TutorRow";

class Tutors extends Component {
    render() {
        return (
            <div id="tutorsIndex">
                <h1><i className="fas fa-users" /> Tutors </h1>
                <p style={{color: '#5a5a5a'}}>We are a family company that is united by a love for teaching & diverse specializations! Everyone of our tutors is highly experienced in both teaching and their subject matters.</p>
                <TutorRow
                    img="https://i.imgur.com/PqCxOgo.jpg"
                    name="Dr. Neelam Sharma"
                    subjects="Chemistry"
                    bio="Dr. Neelam Sharma has been teaching professionally for the past 30 years. She has taught Chemistry at all levels including Collegiate, High School, Advanced Placement and Private Tutoring. Dr. Sharma currently teaches at the prestigious Science Park High School in Newark, NJ. She holds a PhD in Chemistry from the prestigious IIT university in India! When not teaching, she loves to cook and spend time with her family."
                />
                <br/>
                <TutorRow
                    img="https://i.imgur.com/3B2oKbU.jpg"
                    name="Dr. Nevadita Sharma"
                    subjects="Biology"
                    bio="Dr. Nevadita Sharma has been teaching Biology as an Assistant Professor for the past 10 years. During this time, she also conducted breakthrough research on IVFs while also helping over 50 students with their own dissertations. She holds a PhD in Microbiology and Biotechnology AND an MBA! Dr. Sharma loves watching movies and playing with her dog in her spare time :)"
                />
                <br/>
                <TutorRow
                    img="https://i.imgur.com/R9fA84C.jpg"
                    name="Adhaar Sharma"
                    subjects="Math, Computer Science"
                    bio="Adhaar Sharma has been tutoring students since he was 15. He loves numbers and computers and is currently CEO of a technology startup www.woyera.com! Adhaar loves to break down complex topics into simple words and his students love him for it. He holds a BS in Chemical Engineering from Rutgers University and a MS in Computer Science (Machine Learning) from Georgia Tech. Adhaar loves the outdoors, going hiking and to the beach!"
                />
                <br/>
                <TutorRow
                    img="https://i.imgur.com/kcRdUJC.jpg"
                    name="Alok Sharma"
                    subjects="Math, Hindi"
                    bio="Alok Sharma has been teaching students ever since he saw his father teach at a young age. He has been a practicing Accountant for the past 30 years and has an immense understanding of Algebra and Math. Alok is also a fan of hindi poetry and has an in-depth knowledge of the language. He loves to say that life is full of teachable moments and tries to spread the message whenever he can!"
                />
            </div>
        )
    }
}

export default Tutors